/**
 * Guest favorites — client-side "saved for later" list for visitors
 * browsing in guest mode. Stored entirely in localStorage until the
 * visitor signs up (at which point we can lift them into the user's
 * real account — backend sync is P1 backlog).
 *
 * Shape of each item:
 *   { type, slug, title, image, state, city, price, addedAt }
 */
const FAVS_KEY = 'iariya_guest_favorites';
const LAST_SIGNUP_PROMPT_KEY = 'iariya_guest_favs_last_prompt';

function readAll() {
  try {
    const raw = localStorage.getItem(FAVS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function writeAll(items) {
  try {
    localStorage.setItem(FAVS_KEY, JSON.stringify(items.slice(0, 50)));
    window.dispatchEvent(new CustomEvent('iariya:guest-favorites-changed', { detail: items }));
  } catch {
    // ignore — quota or incognito mode
  }
}

export function getFavorites() {
  return readAll();
}

export function isFavorited(type, slug) {
  return readAll().some((f) => f.type === type && f.slug === slug);
}

export function favoriteCount() {
  return readAll().length;
}

export function toggleFavorite(entry) {
  const key = `${entry.type}:${entry.slug}`;
  const list = readAll();
  const idx = list.findIndex((f) => `${f.type}:${f.slug}` === key);
  if (idx >= 0) {
    list.splice(idx, 1);
    writeAll(list);
    return false; // now un-favorited
  }
  list.unshift({ ...entry, addedAt: Date.now() });
  writeAll(list);
  return true; // now favorited
}

export function clearFavorites() {
  writeAll([]);
}

/**
 * Returns true if we should surface the sign-up modal NOW. Used to avoid
 * showing it every single save — pop on count 1, 3, 5 and at most once per
 * hour within a session.
 */
export function shouldPromptSignup() {
  try {
    const count = favoriteCount();
    if (count === 0) return false;
    const lastPrompt = parseInt(localStorage.getItem(LAST_SIGNUP_PROMPT_KEY) || '0', 10);
    const oneHour = 60 * 60 * 1000;
    if (Date.now() - lastPrompt < oneHour) return false;
    // Prompt on 1st, 3rd, and 5th save; after that every 5 saves.
    if (count === 1 || count === 3 || count === 5) return true;
    if (count > 5 && count % 5 === 0) return true;
    return false;
  } catch {
    return false;
  }
}

export function recordSignupPrompt() {
  try {
    localStorage.setItem(LAST_SIGNUP_PROMPT_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}
